<template>
  <div
      @click="handleClick"
      class="arrow">
  </div>
</template>

<style scoped lang="scss">
.arrow {
  position: absolute;
  z-index: 15;
  top: 92vh;
  left: calc(50% - 1.25rem);
  cursor: pointer;
  animation-duration: 2.5s;
  animation-iteration-count: 1;
  animation-name: fadeIn;

  @media screen and (max-width: $tablet) {
    display: none;
  }
}

.arrow:before {
  position: absolute;
  left: 50%;
}

.arrow {
  width: 2.5rem;
  height: 2.5rem;
  transform: rotate(45deg);
  border-left: none;
  border-top: none;
  border-right: 2px $primary solid;
  border-bottom: 2px $primary solid;
}

.arrow:before {
  content: '';
  width: 1.25rem;
  height: 1.25rem;
  top: 50%;
  margin: -10px 0 0 -10px;
  border-left: none;
  border-top: none;
  border-right: 1px $primary solid;
  border-bottom: 1px $primary solid;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-name: arrow;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes arrow {
  0% {
    opacity: 1;
  }
  75% {
    opacity: 0;
    transform: translate(-10px, -10px);
  }
  100% {
    opacity: 0;
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ADownArrow extends Vue {
  handleClick (e: Event) {
    // @ts-ignore
    const sibling = e.target.nextElementSibling;
    sibling.nextElementSibling.scrollIntoView({
      behavior: 'smooth'
    });
  }
}
</script>
